<h2 mat-dialog-title class="dialog-header">
  <div class="header-left">
    <mat-icon class="header-icon">attach_file</mat-icon>
    UPLOAD ATTACHMENT
  </div>
  <button type="button" aria-label="Close" (click)="onCancelClick()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <div class="file-upload-container">

    <!-- Header Row: Text Left, Button Right -->
    <div class="d-flex justify-content-between align-items-start">

      <!-- Left Section: Text & Note -->
      <div class="upload-label">
        <div class="d-flex align-items-center gap-2 mb-1">
          <span class="material-icons">upload</span>
          <span>Browse files to upload</span>
        </div>

        <div class="note text-muted small" *ngIf="allowedFileTypes?.length">
          *Note: Only the file types [{{ getReadableFileTypes() }}] can be selected for upload
        </div>
      </div>

      <!-- Right Section: Browse/Upload Button -->
      <div>
        <input id="fileInput" type="file" style="display: none;" multiple (change)="onFilesSelected($event)"
          [accept]="allowedFileTypes.join(',')" #fileInput />

        <!-- Browse Button -->
        <label *ngIf="files.length === 0" for="fileInput" class="btn btn-warning custom-file-upload">
          Browse
        </label>

        <!-- Upload Button -->
        <button *ngIf="files.length > 0" class="btn btn-success" [disabled]="!isAllFilesValid() || isUploading"
          (click)="uploadFiles()">
          Upload
        </button>
      </div>
    </div>

    <!-- Drag & Drop Area -->
    <div class="drop-zone mt-3" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <p>Drag & Drop files here</p>
    </div>

    <!-- Selected Files List -->
    <div class="row mt-3">
      <div *ngFor="let file of files; let i = index" class="mb-2">
        <div class="file-preview">
          {{ file.name }}
          <span class="material-icons bg-danger text-white ms-2 remove-icon" role="button" tabindex="0"
            (click)="removeFile(i, file.name)" (keydown.enter)="removeFile(i, file.name)" (keydown.space)="removeFile(i, file.name); $event.preventDefault()">close</span>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <div *ngIf="uploadSuccess" class="text-success">
        File uploaded successfully!
      </div>

      <div *ngIf="uploadLimitFailure" class="text-danger">
        Error: You can upload up to {{ maxFilesLimit }} files only.
      </div>

      <div *ngIf="uploadFailure" class="text-danger">
        Error in uploading files.
      </div>

      <div *ngIf="invalidFileTypes?.length" class="text-danger">
        Invalid file type(s): {{ invalidFileTypes.join(', ') }}
      </div>

      <div *ngIf="oversizedFiles?.length" class="text-danger">
        File(s) exceeding {{ maxFileSizeMB }} MB: {{ oversizedFiles.join(', ') }}
      </div>
    </div>
  </div>
</mat-dialog-content>